<template>
  <div>
    <alarm-status
      v-if="hasOnlyOne"
      class="alarm-status__label"
      :alarmStatus="alarmStatus"
      :displaying="displaying"
    />
    <b-button
      v-else
      class="alarm-status__link"
      variant="link"
      @click="onClickLinkHandler()"
    >
      {{ label }}
    </b-button>
  </div>
</template>

<script>
import AlarmStatus from './AlarmStatus';

export default {
  components: {
    AlarmStatus,
  },
  props: {
    displaying: {
      type: Boolean,
      default: true,
    },
    alarms: {
      type: Array,
      required: true,
    },
    diagnostic: {
      type: Object,
      required: true,
    },
  },
  computed: {
    alarmStatus() {
      const [alarm] = this.alarms;
      return alarm || false;
    },
    hasOnlyOne() {
      return (this.alarms || []).length === 1;
    },
    label() {
      const amount = (this.alarms || []).length;
      return `+${amount}`;
    },
  },
  methods: {
    onClickLinkHandler() {
      this.$emit('click-link', this.diagnostic);
    },
  },
};
</script>

<style lang="sass" scoped>
  .alarm-status
    &__link
      color: var(--color-info)
      text-decoration: underline
      cursor: pointer
      padding: 0
      &:hover
        color: var(--color-info)
</style>
